<div class="rpt-container">

    <!-- Onglets dynamiques -->
    <div class="rpt-tabs-wrapper" *ngIf="sheetNames.length > 1">
        <div class="rpt-tabs" [class.rpt-tabs-daily]="dailyStop">
            <button 
                *ngFor="let sheet of sheetNames; let i = index" 
                (click)="selectSheet(i)"
                [class.rpt-active]="currentSheet === i" 
                [title]="sheet">
                {{ sheet }}
            </button>
        </div>
    </div>

    <!-- Contenu de la feuille active -->
    <div *ngIf="getActiveSheetData().length > 0" class="rpt-table-container">
        <table>
            <thead>
                <!-- Ligne de titre -->
                <tr *ngIf="getRow(0)?.length" class="rpt-title-row">
                    <th colspan="2">
                        <span class="fw-semibold">{{ currentUser.username | uppercase }}</span>
                    </th>
                    <th [attr.colspan]="getHeaders().length - 4" 
                        style="text-align: center; font-size: 15px;">
                        {{ getTitleInfo().title }}
                    </th>
                    <th colspan="2" style="text-align: right; white-space: pre-line; font-size: 12px;">
                        {{ getTitleInfo().info }}
                    </th>
                </tr>

                <!-- Ligne d'en-tête -->
                <tr class="rpt-header-row">
                    <th *ngFor="let header of getHeaders()">
                        {{ header }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let row of getFilteredData(); let rowIndex = index">
                    <tr [ngClass]="getRowClass(row)">
                        <td *ngFor="let header of getHeaders(); let colIndex = index"
                            class="rpt-truncate-cell"
                            [style.font-weight]="isTotalRow(row) ? 'bold' : 'normal'">

                            <!-- Cas des coordonnées -->
                            <ng-container *ngIf="isMapLink(header, row[colIndex]) && !isTotalRow(row) && !isTotalHoursRow(row)">
                                <a href="{{ getGoogleMapsLink(row[colIndex]) }}" 
                                   target="_blank" 
                                   class="rpt-map-link"
                                   title="Voir sur Google Maps">
                                    <i class="fas fa-map-marker-alt"></i>
                                    {{ row[colIndex] }}
                                </a>
                            </ng-container>

                            <!-- Cas des durées -->
                            <ng-container *ngIf="!isMapLink(header, row[colIndex]) || isTotalRow(row) || isTotalHoursRow(row)">
                                <ng-container *ngIf="isDayFractionDurationColumn(header) && !isTotalHoursRow(row); else checkMinutes">
                                    {{ formatDurationAsDaysHMS(row[colIndex]) }}
                                </ng-container>
                                <ng-template #checkMinutes>
                                    <ng-container *ngIf="isDurationColumn(header); else normalCell">
                                        {{ formatDuration(row[colIndex]) }}
                                    </ng-container>
                                    <ng-template #normalCell>
                                        {{ getCellValue(row, colIndex, header) }}
                                    </ng-template>
                                </ng-template>
                            </ng-container>
                        </td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
    </div>

    <!-- Message quand aucune donnée -->
    <div *ngIf="sheetNames.length === 0 || getActiveSheetData().length === 0" class="rpt-no-data">
        <i class="fas fa-info-circle"></i>
        Aucune donnée disponible.
    </div>

</div>